import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// ScrollToPluginを登録
gsap.registerPlugin(ScrollToPlugin);

export default class {
    constructor() {
        this.links = null;
    }

    init() {
        this.links = document.querySelectorAll('.s-about-navigation__link');
        this.bindEvents();
        this.handleHashScroll();
    }

    bindEvents() {
        this.links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.smoothScroll(link.getAttribute('href'));
            });
        });
    }

    smoothScroll(targetId) {
        const targetElement = document.querySelector(targetId);
        if (!targetElement) return;

        const headerHeight = this.getHeaderHeight();
        const targetPosition = targetElement.offsetTop - headerHeight; // 20pxの余白を追加

        gsap.to(window, {
            duration: .7,
            scrollTo: {
                y: targetPosition,
                autoKill: false
            },
            ease: "power2.inOut"
        });
    }

    handleHashScroll() {
        // URLにハッシュがある場合、ページ読み込み後に自動スクロール
        if (window.location.hash) {
            // ページの読み込みが完了してからスクロール
            setTimeout(() => {
                this.smoothScroll(window.location.hash);
            }, 100);
        }
    }

    getHeaderHeight() {
        const header = document.querySelector('header');
        return header ? header.offsetHeight : 0;
    }
} 